import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'satisfacao-pos-consulta',
    title: 'Satisfação pós-consulta',
    description: 'Colete feedback dos clientes logo após a consulta para avaliar a qualidade do atendimento.',
    indicatedFor: 'Nutricionistas',
    stepsCount: 1,
    questionsSummary: ['Nota da consulta', 'Clareza das orientações', 'Pontos de melhoria', 'Indicaria?'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Como foi sua consulta?',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Sua opinião',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar avaliação',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: 'Como você avalia a consulta de hoje?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Muito ruim',
                            maxLabel: 'Excelente',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'scale',
                        label: 'As orientações foram claras e fáceis de entender?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Nada claras',
                            maxLabel: 'Muito claras',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'O que podemos melhorar no atendimento?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'yes_no_maybe',
                        label: 'Você indicaria nossa consultoria para um amigo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
